import { Navigate, useLocation } from 'react-router-dom';

const ViewportRedirect = () => {
  const { pathname, search, hash } = useLocation();
  const stripped = pathname.replace(/\/viewport(?=\/|$)/i, '');
  const to = stripped === pathname ? '..' : `${stripped}${search}${hash}`;
  return <Navigate to={to} replace />;
};

export default ViewportRedirect;
